// extracted by mini-css-extract-plugin
export default {"p-footer-link":"footer_p-footer-link__R8fc4"};